import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'

// Packages
import { reduxForm } from 'redux-form'

// Components
import ContactFormCategory from '../../../../../components/UserPortal/Locker/Contact/ContactFormCategory';


class LockerContactForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    participation: PropTypes.object.isRequired
  }

  contactCategories = () => {
    const {school, ...contacts} = this.props.participation.contacts
    return Object.keys(contacts)
  }

  render() {
    return (
      <form onSubmit={this.props.handleSubmit}>
        {
          this.contactCategories().map((category, index) => (
            <ContactFormCategory category={category} key={index} />
          ))
        }
        <button className="cta-gradient" type="submit">
          Save Changes
        </button>
      </form>
    )
  }
}

// Connect to redux-form
LockerContactForm = reduxForm({
  form: 'LockerContactForm'
})(LockerContactForm)


// Connect to redux
const mapStateToProps = (state, ownProps) => {
  const { school, ...contacts } = ownProps.participation.contacts

  return ({
    initialValues: {
      contacts
    }
  })
}

export default connect(mapStateToProps)(LockerContactForm)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Locker/LockerScreens/LockerContactForm/LockerContactForm.js